import { customTextBlock, paragraph } from "../../../text/nodes"
import { StarTestimonial as StarTestimonialEditor } from "./star-testimonial"
import { StarTestimonialSettings } from "./star-testimonial-settings"
import StarTestimonialPreview from "./star-testimonial-preview.png"
import { getFont } from "../../../shared/fonts"

export const StarTestimonial = {
  name: "StarTestimonial",
  label: "testimonial with stars and image",
  EditorComponent: StarTestimonialEditor,
  SettingsComponent: StarTestimonialSettings,
  image: StarTestimonialPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    textColor: "#4d4d4d",
    textFontFamily: getFont("System Font"),
    nameColor: "#4d4d4d",
    image: "",
    alt: "",
    horizontalPadding: 18,
    verticalPadding: 18,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    imageBorderRadius: 0,
    columnRatio: 40,
    borderColor: "#e3e3e3",
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1
  },
  defaultChildren: [
    customTextBlock([
      paragraph(
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultrices vehicula erat, eu faucibus ligula viverra sit amet."
      )
    ]),
    customTextBlock([
      {
        object: "block",
        type: "paragraph",
        nodes: [
          {
            object: "text",
            leaves: [
              {
                object: "leaf",
                text: "Name",
                marks: [
                  {
                    object: "mark",
                    type: "bold",
                    data: {}
                  }
                ]
              }
            ]
          }
        ]
      }
    ])
  ]
}
